export default __webpack_public_path__ + "static/media/fsw_5.ba6e77cd.png";